/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateVatRequest,
  GetAllForOrganisationParams,
  GetVatListForOrganisationParams,
  InfiniteScrollListVatDtoObject,
  InitiateDefaultVatRequest,
  UpdateVatRequest,
  VatBulkUpdateRequest,
  VatDto,
  VatFilterRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiTransactionVatController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetVatById
   * @summary Return vat by vat id
   * @request GET:/api/v1/vat/{vatId}
   */
  getVatById = (vatId: string, params: RequestParams = {}) =>
    this.http.request<VatDto, any>({
      path: `/v1/vat/${vatId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVatByIdPath = '/v1/vat/${vatId}'
  static getVatByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name UpdateVat
   * @request PUT:/api/v1/vat/{vatId}
   */
  updateVat = (vatId: string, data: UpdateVatRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/vat/${vatId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateVatPath = '/v1/vat/${vatId}'
  static updateVatMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name DeleteVat
   * @request DELETE:/api/v1/vat/{vatId}
   */
  deleteVat = (vatId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/vat/${vatId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteVatPath = '/v1/vat/${vatId}'
  static deleteVatMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name BulkUpdateVats
   * @request PUT:/api/v1/vat/bulk-update
   */
  bulkUpdateVats = (data: VatBulkUpdateRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/vat/bulk-update`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateVatsPath = '/v1/vat/bulk-update'
  static bulkUpdateVatsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetAllForOrganisation
   * @request GET:/api/v1/vat
   */
  getAllForOrganisation = (query: GetAllForOrganisationParams, params: RequestParams = {}) =>
    this.http.request<VatDto[], any>({
      path: `/v1/vat`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllForOrganisationPath = '/v1/vat'
  static getAllForOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name CreateVat
   * @request POST:/api/v1/vat
   */
  createVat = (data: CreateVatRequest, params: RequestParams = {}) =>
    this.http.request<VatDto, any>({
      path: `/v1/vat`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createVatPath = '/v1/vat'
  static createVatMethod = 'POST'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetVatsPaged
   * @request POST:/api/v1/vat/paged
   */
  getVatsPaged = (data: VatFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListVatDtoObject, any>({
      path: `/v1/vat/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getVatsPagedPath = '/v1/vat/paged'
  static getVatsPagedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name InitDefaultVatForOrganisation
   * @request POST:/api/v1/vat/init
   */
  initDefaultVatForOrganisation = (data: InitiateDefaultVatRequest, params: RequestParams = {}) =>
    this.http.request<VatDto[], any>({
      path: `/v1/vat/init`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static initDefaultVatForOrganisationPath = '/v1/vat/init'
  static initDefaultVatForOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetVatByIds
   * @summary Receive a list of vat ids separate by comma and returns a list of vat
   * @request GET:/api/v1/vat/{vatIds}
   */
  getVatByIds = (vatIds: string[], params: RequestParams = {}) =>
    this.http.request<VatDto[], any>({
      path: `/v1/vat/${vatIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVatByIdsPath = '/v1/vat/${vatIds}'
  static getVatByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetTemplates
   * @request GET:/api/v1/vat/templates
   */
  getTemplates = (params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/vat/templates`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTemplatesPath = '/v1/vat/templates'
  static getTemplatesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-transaction-vat-controller
   * @name GetVatListForOrganisation
   * @request GET:/api/v1/vat/list
   * @deprecated
   */
  getVatListForOrganisation = (
    query: GetVatListForOrganisationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<VatDto[], any>({
      path: `/v1/vat/list`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getVatListForOrganisationPath = '/v1/vat/list'
  static getVatListForOrganisationMethod = 'GET'
}
